var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"elevation":"0"}},[_c('v-card-title',[_vm._v("簡単ログイン設定")]),(_vm.retired)?_c('password-retired-notice',{attrs:{"title":"このログイン方法は終了しました","message":"「メールでログイン」をお使いください。","show-login-button":false}}):_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }